// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
// This file was automatically generated, run yarn gen:gql to update it
/* eslint-disable */

import type * as Types from '../../../schema/public';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CurrentUserQueryVariables = Types.Exact<{
  site: Types.Scalars['String']['input'];
}>;


export type CurrentUserQuery = { __typename?: 'Query', features?: { __typename?: 'Features', id: string, walletCurrency?: string }, userManagement?: { __typename?: 'UserManagement', id: string, user?: { __typename: 'UserManagementUser', id: string, email?: string, username?: string, signupTime?: number, authMethods?: Array<string> }, profile?: { __typename: 'UserManagementProfile', _id?: string, id: string, firstName?: string, lastName?: string, maidenName?: string, email?: string, country?: string, phone?: string, affiliateID?: string, city?: string, zip?: string, house?: string, lineId?: string, telegramId?: string, address?: string, state?: string, dateOfBirth?: number, language?: string, conversionCurrency?: string, hasOtp?: boolean, hasSMS2FA?: boolean, emailVerified?: boolean, passwordChangeDate?: number, contactsRequestedTime?: number, allowUsernameChange?: boolean, settings?: { __typename?: 'UserManagementSettings', siteTheme?: string, wallets?: string, loyaltyLandingDisabled?: string, loyaltyLevelNotfDisabled?: string, gameNamesInEnglish?: string, verifyEmailClosed?: string, rtpLiveOnboardingClosed?: string, preferredInGameCurrency?: string, inGameCurrencyOnboardingClosed?: string } }, countryInfo?: { __typename: 'UserManagementCountryInfo', id: string, countryCode?: string, blocked?: boolean } } };

export type UserManagementFragment = { __typename?: 'UserManagement', id: string, user?: { __typename: 'UserManagementUser', id: string, email?: string, username?: string, signupTime?: number, authMethods?: Array<string> }, profile?: { __typename: 'UserManagementProfile', _id?: string, id: string, firstName?: string, lastName?: string, maidenName?: string, email?: string, country?: string, phone?: string, affiliateID?: string, city?: string, zip?: string, house?: string, lineId?: string, telegramId?: string, address?: string, state?: string, dateOfBirth?: number, language?: string, conversionCurrency?: string, hasOtp?: boolean, hasSMS2FA?: boolean, emailVerified?: boolean, passwordChangeDate?: number, contactsRequestedTime?: number, allowUsernameChange?: boolean, settings?: { __typename?: 'UserManagementSettings', siteTheme?: string, wallets?: string, loyaltyLandingDisabled?: string, loyaltyLevelNotfDisabled?: string, gameNamesInEnglish?: string, verifyEmailClosed?: string, rtpLiveOnboardingClosed?: string, preferredInGameCurrency?: string, inGameCurrencyOnboardingClosed?: string } }, countryInfo?: { __typename: 'UserManagementCountryInfo', id: string, countryCode?: string, blocked?: boolean } };

export type UserFragment = { __typename: 'UserManagementUser', id: string, email?: string, username?: string, signupTime?: number, authMethods?: Array<string> };

export type ProfileFragment = { __typename: 'UserManagementProfile', _id?: string, id: string, firstName?: string, lastName?: string, maidenName?: string, email?: string, country?: string, phone?: string, affiliateID?: string, city?: string, zip?: string, house?: string, lineId?: string, telegramId?: string, address?: string, state?: string, dateOfBirth?: number, language?: string, conversionCurrency?: string, hasOtp?: boolean, hasSMS2FA?: boolean, emailVerified?: boolean, passwordChangeDate?: number, contactsRequestedTime?: number, allowUsernameChange?: boolean, settings?: { __typename?: 'UserManagementSettings', siteTheme?: string, wallets?: string, loyaltyLandingDisabled?: string, loyaltyLevelNotfDisabled?: string, gameNamesInEnglish?: string, verifyEmailClosed?: string, rtpLiveOnboardingClosed?: string, preferredInGameCurrency?: string, inGameCurrencyOnboardingClosed?: string } };

export type CountryInfoFragment = { __typename: 'UserManagementCountryInfo', id: string, countryCode?: string, blocked?: boolean };

export const UserFragmentDoc = /*#__PURE__*/ gql`
    fragment UserFragment on UserManagementUser {
  __typename
  id
  email
  username
  signupTime
  authMethods
}
    `;
export const ProfileFragmentDoc = /*#__PURE__*/ gql`
    fragment ProfileFragment on UserManagementProfile {
  __typename
  _id
  id
  firstName
  lastName
  maidenName
  email
  country
  phone
  affiliateID
  city
  zip
  house
  lineId
  telegramId
  address
  state
  dateOfBirth
  language
  conversionCurrency
  hasOtp
  affiliateID
  hasSMS2FA
  emailVerified
  passwordChangeDate
  contactsRequestedTime
  allowUsernameChange
  settings {
    siteTheme: setting(name: siteTheme)
    wallets: setting(name: wallets)
    loyaltyLandingDisabled: setting(name: loyaltyLandingDisabled)
    loyaltyLevelNotfDisabled: setting(name: loyaltyLevelNotfDisabled)
    gameNamesInEnglish: setting(name: gameNamesInEnglish)
    verifyEmailClosed: setting(name: verifyEmailClosed)
    rtpLiveOnboardingClosed: setting(name: rtpLiveOnboardingClosed)
    preferredInGameCurrency: setting(name: preferredInGameCurrency)
    inGameCurrencyOnboardingClosed: setting(name: inGameCurrencyOnboardingClosed)
  }
}
    `;
export const CountryInfoFragmentDoc = /*#__PURE__*/ gql`
    fragment CountryInfoFragment on UserManagementCountryInfo {
  __typename
  id
  countryCode
  blocked
}
    `;
export const UserManagementFragmentDoc = /*#__PURE__*/ gql`
    fragment UserManagementFragment on UserManagement {
  id
  user: currentUser {
    ...UserFragment
  }
  profile: currentProfile {
    ...ProfileFragment
  }
  countryInfo: currentCountryInfo(site: $site) {
    ...CountryInfoFragment
  }
}
    ${UserFragmentDoc}
${ProfileFragmentDoc}
${CountryInfoFragmentDoc}`;
export const CurrentUserQueryDocument = /*#__PURE__*/ gql`
    query CurrentUserQuery($site: String!) {
  features {
    id
    walletCurrency: myGroupTag(name: "DepositCurrency")
  }
  userManagement {
    id
    ...UserManagementFragment
  }
}
    ${UserManagementFragmentDoc}`;
export function useCurrentUserQuery(baseOptions: Apollo.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables> & ({ variables: CurrentUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserQueryDocument, options);
      }
export function useCurrentUserQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserQueryDocument, options);
        }
export function useCurrentUserQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserQueryDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserQueryLazyQueryHookResult = ReturnType<typeof useCurrentUserQueryLazyQuery>;
export type CurrentUserQuerySuspenseQueryHookResult = ReturnType<typeof useCurrentUserQuerySuspenseQuery>;
export type CurrentUserQueryQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;